import type { AxiosRequestConfig } from 'axios'

const SIGN_UP_BOT_PROTECTION_ENABLED =
  import.meta.env.VITE_APP_SIGN_UP_BOT_PROTECTION_ENABLED === 'true'

const siteKey = normalizeTurnstileEnvironmentValue(import.meta.env.VITE_APP_TURNSTILE_SITE_KEY)

export const getTurnstileRequestConfig = (turnstileToken?: string): AxiosRequestConfig =>
  turnstileToken
    ? {
        headers: {
          'x-turnstile-token': turnstileToken
        }
      }
    : {}

export const getTurnstileConfiguration = () => ({
  enabled: SIGN_UP_BOT_PROTECTION_ENABLED,
  siteKey
})

function normalizeTurnstileEnvironmentValue(value: string | undefined): string | undefined {
  if (!value) {
    return undefined
  }

  const trimmedValue = value.trim()
  const quote = trimmedValue[0]
  const hasMatchingQuotes = (quote === '"' || quote === "'") && trimmedValue.at(-1) === quote

  return hasMatchingQuotes ? trimmedValue.slice(1, -1) : trimmedValue
}
